import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
// import { InputField } from "../../../../Components/formElements/InputField";
// import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
// import { validateRequired } from "../../../../common/Validations";
// import toast from "react-hot-toast";
import GoogleMapComponentFromTo from "../../Common/GoogleMapComponentFromTo";

const newProject = {
  projectCode: 1,
  projectCodeDesc: "PROJECT_1",
  projectName: "",
  projectAddress: "",
  projectAddress2: "",
  projectCity: "",
  projectCountry: "IN - India",
  projectState: "IN - Karanataka",
  projectCityPostalCode: "",
  getProjectContactPerson: [
    {
      id: Date.now(),
      projectContactPosition: "",
      projectContactTitle: "",
      projectContactName: "",
      projectContactNumber: "",
      projectContactEmail: "",
    },
  ],
  getProjectCertifications: [
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      certificateCode: "29AADCN1012B1Z6",
      stageDocument: "",
    },
  ],
  getLocations: [],
};

const TrackModal = React.forwardRef((props, ref) => {
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [getProjectDetails, setProjectDetails] = useState([newProject]);
  const [getData, setData] = useState();

  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    setData(props?.data);
    setProjectDetails(props?.data?.loactionDetails && props?.data?.loactionDetails);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);


  // console.log(">>getData",getData)

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Track - {getData?.documentNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"}`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} className="text-center logoBtn">
                  <span className="iconLogo">LN</span>
                </Col>
                <Col xs={8}>
                  <span className="headerTitle">Location Details</span>
                  <span className="subHeaderTitle">Location Details</span>
                </Col>
                <Col xs={2}>
                  <div className="d-flex justify-content-end p-2 me-3"></div>
                </Col>
              </Row>
            </h2>
            <div className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""}`}>
              <div className="accordion-body">
                {getProjectDetails?.map((item, index) => (
                  <div key={index}>
                    <Row>
                      <Col xs={12} className="commTopButtonRightLeftPadding">
                        <h5 className="bg-table-status bg-table-warning-status mt-4">
                          Locations
                        </h5>
                        <GoogleMapComponentFromTo
                          projectIndex={index}
                          // getmapdata={onHandleMapData}
                          passmapdata={item?.getLocations || []}
                          editstatus={true}
                        />
                      </Col>
                    </Row>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default TrackModal;
